export const Tenants = {
  DEV: 'dev',
  CBDEMO: 'cbdemo',
  ARVADA: 'arvada',
  STAGING: 'staging',
  CENTRALIOWA: 'centraliowa',
  DEMO: 'demo',
  CROELL: 'croell',
  IMI: 'imi',
  MOHICANVALLEY: 'mohicanvalley',
  BARTOO: 'bartoo',
  MANATTS: 'manatts',
  ELVINGROUP: 'elvingroup',
  NORWALK: 'norwalk',
  LOVELAND: 'loveland',
  CAJUN: 'cajun',
  HANFORD: 'hanford',
  ZANOWS: 'zanows',
  OCEANCONCRETE: 'oceanconcrete',
  LIBERTY: 'liberty',
  TITAN: 'titan',
  KOY: 'koy',
  CARDI: 'cardi',
  BAKERSHINDLER: 'bakershindler',
  CULLION: 'cullion',
  CUSTOM: 'custom',
  CHOATE: 'choate',
  MAGNO: 'magno',
  COWTOWN: 'cowtown',
  TNT: 'tnt',
  NBREADYMIX: 'nbreadymix',
  TECHCRETE: 'techcrete',
  DOLESE: 'dolese',
  DAUPHINAIS: 'dauphinais',
  CSC: 'csc',
  SEVILLE: 'seville',
  CSI: 'csi',
  KOST: 'kost',
  TORROMEO: 'torromeo',
  MDC: 'mdc',
  PRISMA: 'prisma',
  PEPI: 'pepi',
  PROVIMIX: 'provimix',
  BEAR: 'bear',
  CT: 'ct',
  OBAX: 'obax',
  HERCULES: 'hercules',
  JMI: 'jmi',
  MACK: 'mack',
  PMATERIALS: 'pmaterials',
  PROMIX: 'promix',
  BAJA: 'baja',
  NEWBERLIN: 'newberlin',
  OBRIEN: 'obrien',
  STEVENSON: 'stevenson',
  OGINDUSTRIES: 'ogindustries',
  JARCO: 'jarco',
  HALLETT: 'hallett',
  SUNRISE: 'sunrise',
  DIAMOND: 'diamond',
  TT: 'tt',
  BOSTON: 'boston',
  SYRIS: 'syris',
  RAPTOR: 'raptor',
  BIGD: 'bigd',
  SHORTYCRETE: 'shortycrete',
  TERREBONNE: 'terrebonne',
  UNIVERSAL: 'universal',
  HALEY: 'haley',
  CORE: 'core',
  CRETER: 'creter',
  FF: 'ff',
  SCRANTON: 'scranton',
  MONARO: 'monaro',
  CCRM: 'ccrm',
  YJ: 'yj',
  COUNTRYMIX: 'countrymix',
  ADAMSDALE: 'adamsdale',
  SCHRIEVER: 'schriever',
  WESTERN: 'western',
  WESTERNGRAVEL: 'westerngravel',
  DOLESE_SANDBOX: 'dolese-sandbox',
  ATLASCONCRETE_SANDBOX: 'atlasconcrete-sandbox',
  RHINO: 'rhino',
  HIPLAINSSAND: 'hiplainssand',
  CCREDIMIX: 'ccredimix',
  AVE: 'ave',
  CAYCO: 'cayco',
  OTSEGO: 'otsego',
  TANAS: 'tanas',
  WHISTLE: 'whistle',
  PILARES: 'pilares',
  LLCONCRETE: 'llconcrete',
  OG_SANDBOX: 'og-sandbox',
  PIEDMONT: 'piedmont',
  SALOMONE: 'salomone',
  BABCOCKSUPPLY: 'babcocksupply',
  CPBCON: 'cpbcon',
  MPC: 'mpc',
  HUGHESBROS: 'hughesbros',
  CONCRETOSCRUZ: 'concretoscruz',
  BIGAPPLE: 'bigapple',
  ALLAMERICAN: 'allamerican',
  CITYTRANSIT: 'citytransit',
  NORTHERNLAKES: 'northernlakes',
  ROWEN: 'rowen',
  BOSCONCRETE: 'bosconcrete',
  MANATTSTRAINING: 'manattstraining',
  FELTONBROTHERS: 'feltonbrothers',
  SOLIDROCK: 'solidrock',
  TRANSCO: 'transco',
  CASA: 'casa',
  WAYNE: 'wayne',
  GARYBALE: 'garybale',
  CHANCE: 'chance',
  INTEGRITY: 'integrity',
  DICKINSON: 'dickinson',
  SLABSTACK: 'slabstack',
  COINSA: 'coinsa',
  UAT: 'uat',
  JENCO: 'jenco',
  TECNOBLOCK: 'tecnoblock',
  TRANSIT: 'transit',
  TARANAKI: 'taranaki',
  HISSONG: 'hissong',
  CASILIO: 'casilio',
  ULTRA: 'ultra',
  MAINLINE: 'mainline',
  TEST_DEMO: 'test-demo',
  ATLAS: 'atlas',
  TRUEGRIT: 'truegrit',
};
